<template>
  <div>
    <div class="subcategories" v-if="subcategories.length > 0">
      <div class="subcategories-row">
        <div
          v-for="subcategory in subcategories"
          :key="'sub' + subcategory.id"
          class="subcategory"
          :class="{ active: activeSub == subcategory.id }"
          @click="() => $emit('changeSub', subcategory.id)"
        >
          {{ subcategory.title }}
        </div>
        <div class="category-divider"></div>
        <div
          @click="() => $emit('changeSub', null)"
          class="subcategory"
          :class="{ active: activeSub == null }"
        >
          Alle anzeigen
        </div>
      </div>
      <div
        class="subcategories-row-divider"
        v-if="subsubcategories.length > 0"
      ></div>
      <div
        class="subcategories-row subsubcategories"
        v-if="subsubcategories.length > 0"
      >
        <div
          v-for="subsubcategory in subsubcategories"
          @click="() => $emit('changeSubSub', subsubcategory.id)"
          :key="'subsub' + subsubcategory.id"
          class="subsubcategory"
          :class="{ active: activeSubSub == subsubcategory.id }"
        >
          {{ subsubcategory.title }}
        </div>
        <div class="category-divider"></div>
        <div
          @click="() => $emit('changeSubSub', null)"
          class="subcategory"
          :class="{ active: activeSubSub == null }"
        >
          Alle anzeigen
        </div>
      </div>
    </div>

    <div class="idea-controls">
      <div class="idea-counter">{{ ideasAmount }}</div>
      <div class="grid-toggler">
        <button @click.prevent="gridview = true">
          <img v-if="gridview" src="/img/icons/grid-orange.svg" />
          <svg
            v-if="!gridview"
            id="apps"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Pfad_72"
              data-name="Pfad 72"
              d="M10,13H3a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V14A.945.945,0,0,0,10,13ZM9,20H4V15H9ZM21,2H14a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V3A.945.945,0,0,0,21,2ZM20,9H15V4h5Zm1,4H14a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V14A.945.945,0,0,0,21,13Zm-1,7H15V15h5ZM10,2H3A.945.945,0,0,0,2,3v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V3A.945.945,0,0,0,10,2ZM9,9H4V4H9Z"
              fill="#0e5c84"
            />
            <rect
              id="Rechteck_116"
              data-name="Rechteck 116"
              width="24"
              height="24"
              fill="none"
            />
          </svg>

          <!-- <img v-if="!gridview" src="/img/icons/grid-blue.svg" /> -->
        </button>
        <button @click.prevent="gridview = false">
          <img v-if="gridview" src="/img/icons/list-blue.svg" />

          <svg
            v-if="!gridview"
            id="List"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Pfad_72"
              data-name="Pfad 72"
              d="M21,13H3a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1H21a.945.945,0,0,0,1-1V14A.945.945,0,0,0,21,13Zm-1,7H4V15H20ZM21,2H3A.945.945,0,0,0,2,3v7a.945.945,0,0,0,1,1H21a.945.945,0,0,0,1-1V3A.945.945,0,0,0,21,2ZM20,9H4V4H20Z"
              fill="#f0693a"
            />
            <rect
              id="Rechteck_116"
              data-name="Rechteck 116"
              width="24"
              height="24"
              fill="none"
            />
          </svg>

          <!-- <img v-if="!gridview" src="/img/icons/list-orange.svg" /> -->
        </button>
      </div>
    </div>
    <div class="ideas-grid" v-if="gridview">
      <idea-grid-item v-for="idea in ideas.data" :idea="idea" :key="idea.id" />
    </div>
    <div class="ideas-list" v-if="!gridview">
      <idea-list-item v-for="idea in ideas.data" :idea="idea" :key="idea.id" />
    </div>
    <infinite-loading
      @distance="1"
      @infinite="infiniteHandler"
    ></infinite-loading>
  </div>
</template>

<script>
export default {
  props: [
    "classes",
    "category",
    "activeSub",
    "activeSubSub",
    "subcategories",
    "subsubcategories",
    "ideas",
  ],
  data() {
    return {
      gridview: true,
      page: 1,
      list: [],
    };
  },
  watch: {},
  methods: {
    toggleView() {
      this.gridview = !this.gridview;
    },

    infiniteHandler($state) {
      console.log($state);
      // axios.get(api, {
      //   params: {
      //     page: this.page,
      //   },
      // });
      this.page = this.page + 1;
    },

  },
  mounted() {},
  computed: {
    ideasAmount: function () {
      return this.ideas.total == 1
        ? this.ideas.total + " Idee"
        : this.ideas.total + " Ideen";
    },
  },
};
</script>

<style>
</style>